"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Timeline = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _Playhead = _interopRequireDefault(require("./Playhead"));

var _components = _interopRequireDefault(require("../../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media);
};

var Timeline = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Timeline, _React$Component);

  function Timeline() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "seek", function (e) {
      var _this$props = _this.props,
          duration = _this$props.duration,
          onSeek = _this$props.onSeek,
          isChatTextMedia = _this$props.isChatTextMedia,
          messagesDuration = _this$props.messagesDuration;
      var rect = e.target.getBoundingClientRect();
      var totalDuration = isChatTextMedia ? messagesDuration : duration;
      onSeek({
        s: (e.clientX - (rect.x || rect.left)) / rect.width * totalDuration
      });
    });

    return _this;
  }

  var _proto = Timeline.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        _this$props2$currentT = _this$props2.currentTime,
        currentTime = _this$props2$currentT === void 0 ? 0 : _this$props2$currentT,
        _this$props2$duration = _this$props2.duration,
        duration = _this$props2$duration === void 0 ? 0 : _this$props2$duration,
        isSentimentAnalyzerOn = _this$props2.isSentimentAnalyzerOn,
        isChatTextMedia = _this$props2.isChatTextMedia,
        messagesDuration = _this$props2.messagesDuration;
    var totalDuration = isChatTextMedia ? messagesDuration : duration;
    var progress = currentTime / totalDuration * 100 || 0;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].Timeline, null, /*#__PURE__*/_react["default"].createElement(_components["default"].TimelineBody, null, /*#__PURE__*/_react["default"].createElement(_Playhead["default"], {
      isChatTextMedia: isChatTextMedia,
      onSeek: this.seek,
      progress: progress,
      isSentimentAnalyzerOn: isSentimentAnalyzerOn
    }), children));
  };

  return Timeline;
}(_react["default"].Component);

exports.Timeline = Timeline;

_defineProperty(Timeline, "defaultProps", {
  color: "black"
});

Timeline.propTypes = process.env.NODE_ENV !== "production" ? {
  duration: _propTypes["default"].number,
  currentTime: _propTypes["default"].number,
  children: _propTypes["default"].node,
  contextMediaElement: _propTypes["default"].instanceOf(Element)
} : {};

var _default = (0, _connectToMedia["default"])(mapStateToProps)(Timeline);

exports["default"] = _default;